/**
 * Single source of truth for backend endpoint paths.
 * Use these constants instead of string-literal URLs in components so a future
 * API rename / version bump can be done in one place.
 */
export const endpoints = {
  auth: {
    login: '/api/auth/login',
    verifyOtp: '/api/auth/verify-otp',
    resendOtp: '/api/auth/resend-otp',
    register: '/api/auth/register',
  },
  users: {
    me: '/api/users/me',
    mePermissions: '/api/users/me/permissions',
    meProfile: '/api/users/me/profile',
    mePassword: '/api/users/me/password',
    list: '/api/users',
  },
  adminUsers: {
    list: '/api/admin-users',
    one: (id) => `/api/admin-users/${id}`,
    password: (id) => `/api/admin-users/${id}/password`,
    status: (id) => `/api/admin-users/${id}/status`,
  },
  roles: {
    list: '/api/roles',
    all: '/api/roles/all',
    one: (id) => `/api/roles/${id}`,
  },
  access: {
    modules: '/api/access/modules',
    permissions: '/api/access/permissions',
    moduleRolePermissions: (moduleId) => `/api/access/modules/${moduleId}/role-permissions`,
  },
  parties: {
    list: '/api/parties',
    one: (id) => `/api/parties/${id}`,
  },
  brokers: {
    list: '/api/brokers',
    one: (id) => `/api/brokers/${id}`,
  },
  insights: {
    list: '/api/insights',
    one: (id) => `/api/insights/${id}`,
  },
  designs: {
    list: '/api/designs',
    one: (id) => `/api/designs/${id}`,
    pdf: (id) => `/api/designs/${id}/pdf`,
  },
  khatas: {
    list: '/api/khatas',
    one: (id) => `/api/khatas/${id}`,
    machines: (khataId) => `/api/khatas/${khataId}/machines`,
    machine: (khataId, machineId) => `/api/khatas/${khataId}/machines/${machineId}`,
  },
  orders: {
    list: '/api/orders',
    one: (id) => `/api/orders/${id}`,
    detail: (id) => `/api/orders/${id}/detail`,
    activity: (id) => `/api/orders/${id}/activity`,
    transition: (id) => `/api/orders/${id}/transition`,
    hold: (id) => `/api/orders/${id}/hold`,
    release: (id) => `/api/orders/${id}/release`,
    beamStart: (id, beamNo) => `/api/orders/${id}/beams/${beamNo}/start`,
    beamHold: (id, beamNo) => `/api/orders/${id}/beams/${beamNo}/hold`,
    beamResume: (id, beamNo) => `/api/orders/${id}/beams/${beamNo}/resume`,
    beamComplete: (id, beamNo) => `/api/orders/${id}/beams/${beamNo}/complete`,
    beamRowHold: (id, ledgerId) => `/api/orders/${id}/beam-rows/${ledgerId}/hold`,
    beamRowResume: (id, ledgerId) => `/api/orders/${id}/beam-rows/${ledgerId}/resume`,
    beamRowComplete: (id, ledgerId) => `/api/orders/${id}/beam-rows/${ledgerId}/complete`,
    vendorSend: (id) => `/api/orders/${id}/vendor/send`,
    vendorReceive: (id) => `/api/orders/${id}/vendor/receive`,
    dispatch: (id) => `/api/orders/${id}/dispatch`,
    deliver: (id) => `/api/orders/${id}/deliver`,
    pdf: (id, beamIndices) => {
      const base = `/api/orders/${id}/pdf`;
      if (!beamIndices?.length) return base;
      return `${base}?beams=${beamIndices.join(',')}`;
    },
  },
  files: {
    upload: '/api/files/upload',
    uploadProfile: '/api/files/upload/profile',
    uploadOrderDocument: '/api/files/upload/order-document',
  },
  dashboard: {
    summary: '/api/dashboard/summary',
    ordersAnalytics: '/api/dashboard/orders-analytics',
  },
  sales: {
    insights: '/api/sales/insights',
  },
  branding: {
    get: '/api/branding',
    uploadLogo: '/api/branding/logo',
  },
};
